import createInternalRequest from '@/services/create-internal-request'

const integrationsRequest = createInternalRequest(process.env.VUE_APP_INTEGRATIONS_API_ENDPOINT)

export default {
  async getConfig(source) {
    const response = await integrationsRequest({
      method: 'get',
      url: `/config/${source}`,
    })

    return response.data.data
  },
  async uploadCSV({ partner, report_type, partner_portal }, report) {
    const data = new FormData()
    data.append('partner', partner)
    data.append('report_type', report_type)
    data.append('partner_portal', partner_portal)
    data.append('report', report)
    const response = await integrationsRequest({
      method: 'post',
      url: '/events/csv',
      data,
    })

    return response.data.data
  },
  async saveManualCsvEvents({ partner, currency, events }) {
    const data = new FormData()
    data.append('partner', partner)
    data.append('currency', currency)
    data.append('events', events)
    return integrationsRequest({
      method: 'post',
      url: '/events/csv/manual',
      data,
    })
  },
  async getEventLog(params) {
    const response = await integrationsRequest({
      method: 'get',
      url: '/events',
      params,
    })

    return response.data
  },
  async editEvent(uuid, data) {
    return integrationsRequest({
      method: 'put',
      url: `/events/${uuid}`,
      data,
    })
  },
  async deleteEvent(uuid) {
    return integrationsRequest({
      method: 'delete',
      url: `/events/${uuid}`,
    })
  },
  async saveManualEvents(data) {
    return integrationsRequest({
      method: 'post',
      url: '/events/manual',
      data,
    })
  },
  async sendToEventCollector(params = {}) {
    return integrationsRequest({
      method: 'post',
      timeout: 60 * 1 * 1000,
      url: '/events/event-collector',
      params,
    })
  },
}
